import { Helmet } from "react-helmet-async";
import Screen from "../Layouts/Screen/Screen";
import GuidelinesText from "../../global-components/src/components/guidelines-text";

const Guidelines = () => {
    return (
        <>
            <Screen paddingTopTitle={true} title="Diretrizes">
                <Helmet>
                        <title>Paçoca - Diretrizes</title>
                        <meta name="description" content={`Visualize as diretrizes do Paçoca`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Diretrizes, termos, regras}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Diretrizes`}/>
                        <meta property="og:description" content={`Visualize as diretrizes do Paçoca`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Diretrizes`}/>
                        <meta name="twitter:description" content={`Visualize as diretrizes do Paçoca`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet> 

                <div className="padding-big-screen">
                    <GuidelinesText system="Paçoca: rede social brasileira"/>
                </div>
            </Screen>
        </>
    );
};

export default Guidelines;